import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { LOGOUT_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const LogoutRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={LOGOUT_ROUNDED_GLYPH} />;
